const MIXIN_INFO_TEXT = {
  props: {
    labelText: {
      type: String,
      default: ''
    },
    text: {
      type: [String, Number, Boolean],
      default: ''
    },
    isLink: {
      type: Boolean,
      required: false,
      default: false
    },
    href: {
      type: String,
      required: false,
      default: '#'
    },
    isRouterLink: {
      type: Boolean,
      required: false,
      default: false
    },
    route: {
      type: Object,
      default: () => {}
    }
  }
}

export {
  MIXIN_INFO_TEXT
}
